import { Injectable } from '@angular/core';
import { LocationDetailsDto } from '@app/domain/settings/model/location-details.model';
import { Globals } from '@app/shared/globals/globals';
import { NotifyUtils } from '@app/shared/utils/notify.utils';
import { Observable, firstValueFrom } from 'rxjs';
import { LocationDetailsAPIService } from '../../api/location-details/location-details-api.service';
import { SettingsMessages } from '../../locale/settings.messages';
import { InFlightRegistry } from '@app/shared/utils/in-flight-registry';

const WRITE_KEY = 'write';

@Injectable({
  providedIn: 'root'
})
export class LocationDetailsBusinessService {

  // A write already in flight coalesces a duplicate call onto the same promise (see InFlightRegistry)
  // rather than rejecting it, which previously surfaced as an unhandled rejection (Sentry FRONTEND-3HT).
  private writes = new InFlightRegistry();

  constructor(
    private locationDetailsAPIService: LocationDetailsAPIService,
    private notifyUtils: NotifyUtils,
    public globals: Globals
  ) { }

  get(): Observable<LocationDetailsDto> {
    return this.locationDetailsAPIService.get();
  }

  update(userLocationDetails: LocationDetailsDto): Promise<LocationDetailsDto> {
    return this.writes.run(WRITE_KEY, () =>
      firstValueFrom(this.locationDetailsAPIService.update(userLocationDetails))
        .then(res => {
          this.notifyUtils.notify(SettingsMessages.SUCCESS_PROFILE_UPDATED);
          this.globals.user.homeAddress = res.homeAddress;
          this.globals.user.officeLocation = res.officeLocation;
          return res;
        })
    );
  }
}
